import type { ApolloClient } from '@apollo/client';

import {
  ChatFragmentDoc,
  ChatUpdatedSubscription,
} from '@spotify/confidence-graphql';

export type ChatUpdatedOnDataParams = {
  data: { data?: ChatUpdatedSubscription | null };
  client: ApolloClient<object>;
};

export const writeChatToCache = ({
  data: { data },
  client,
}: ChatUpdatedOnDataParams) => {
  const chat = data?.chatUpdated?.chat;
  if (!chat) return;
  client.writeFragment({
    id: client.cache.identify(chat),
    fragment: ChatFragmentDoc,
    fragmentName: 'Chat',
    data: chat,
  });
};
